import React from 'react';
import { LocaleContext } from '../../../../contexts/language';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ar from './ar.json';
import en from './en.json';
import { IntlProvider, FormattedMessage } from 'react-intl';
import Link from '@mui/material/Link';

const languages = {
  ar,
  en
};

export const ListFacetGroup = ({ name, onReset, children }) => {
  const localeConfig = React.useContext(LocaleContext);
  const { direction: dir } = localeConfig;

  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>


      <Stack
        spacing={1}
        sx={{
          mr: dir === 'rtl' ? 2 : undefined,
          ml: dir === 'rtl' ? undefined : 2,
          pb: 3
        }}
      >
        <Stack direction={'row'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#252A31',
              lineHeight: '20px'

            }}
          >
            {name}
          </Typography>
          {onReset ? (
            <Link component={'button'} onClick={onReset}>
              <Typography sx={{ fontSize:'0.8rem' }}>
                <FormattedMessage defaultMessage={'Reset'}
                  id={'facets.reset'} />
              </Typography>
            </Link>

          ) : null}
        </Stack>

        {children}
      </Stack>
    </IntlProvider>
  );
};
ListFacetGroup.propTypes = {
  name: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onReset: PropTypes.function
};